export const types = {
  FETCH_ROUTES: "FETCH_ROUTES",
  FETCH_ROUTES_SUCCESS: "FETCH_ROUTES_SUCCESS",
  FETCH_ROUTES_FOR_MASTER: "FETCH_ROUTES_FOR_MASTER",
  FETCH_ROUTES_FOR_MASTER_SUCCESS: "FETCH_ROUTES_FOR_MASTER_SUCCESS",
};
